
<app-people-picker style="margin-top: 200px;" [minSearchLength]="4" [singleSelection]="true"
    [formControl]="peoplePicker" (inputValChange)="getUsers($event)" (dataSelected)="userData($event)" [searchedData]="searchedData"></app-people-picker>
